var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPinLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 18,
    viewBox: "0 0 13 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.118 6.613a2.495 2.495 0 1 0 4.99 0 2.495 2.495 0 0 0-4.99 0z",
    stroke: "#00C8A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.613 1c3.1 0 5.613 2.513 5.613 5.613 0 2.703-4.268 8.754-5.36 10.259a.313.313 0 0 1-.506 0C5.268 15.367 1 9.316 1 6.613 1 3.513 3.513 1 6.613 1z",
    stroke: "#000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPinLocation);
export default __webpack_public_path__ + "static/media/iconPinLocation.8edff2ff2e0417f32d41ee752b188b37.svg";
export { ForwardRef as ReactComponent };